import allValidWordsRaw from './valid-guesses.txt?raw';

// Process all valid puzzle words (solutions + allowed guesses)
const processValidWords = (rawText: string): string[] => {
  return rawText
    .split('\n')
    .map(word => word.trim().toUpperCase())
    .filter(word => word.length === 5 && /^[A-Z]+$/.test(word));
};

// Export all valid puzzle words for dictionary validation (clean word list)
export const validWords = processValidWords(allValidWordsRaw);
export default validWords;